import { FormLayout, Modal, TextField, Form, Checkbox, Select } from '@shopify/polaris';
import { useEffect, useState } from 'react';

import helpers from 'helpers';

import { lengthLessThan, notEmpty, useField, useForm } from '@shopify/react-form';

import __ from 'languages/index';
import { TypedSeating, useMutateCreateSeating, useMutateGetSeating, useUpdateSeating } from 'queries/seating.query';
import SeatContainer, { SEAT_NOTE, SeatIcon } from 'components/seatContainer';
import seatMaps from 'config/seat-map.json';

/**
 *   Create upload Modal for Notification
 */

// eslint-disable-next-line import/no-anonymous-default-export

export default function SeatingModal({ onClose, show, currentVehicleID }: { onClose: Function; show: boolean; currentVehicleID?: bigint }) {
  const { mutateAsync: createEntity, isPending: creating, isSuccess: creatingSuccess } = useMutateCreateSeating();
  const { mutateAsync: updateEntity, isPending: updating, isSuccess: updateSuccess } = useUpdateSeating();
  const { mutateAsync: getVehicle, data: vehicleData } = useMutateGetSeating();

  /** Hết code lấy user role ra ... */

  const [entity, setEntity] = useState<TypedSeating>(null);
  useEffect(() => {
    if (vehicleData) setEntity(vehicleData);
  }, [vehicleData]);

  useEffect(() => {
    if (currentVehicleID) {
      getVehicle(currentVehicleID);
    } else {
      setEntity(null);
    }
  }, [currentVehicleID]);

  const useFields = {
    seating_name: useField<string>({
      value: entity?.seating_name ?? '',
      validates: [
        notEmpty('Không được để trống trường này.'),
        lengthLessThan(250, 'No more than 250 characters.'),
        (inputValue) => {
          if (inputValue.length < 2) {
            return 'Your field is too short!';
          }
        },
      ],
    }),

    seating_description: useField<string>({
      value: entity?.seating_description ?? '',
      validates: [
        notEmpty('Không được để trống trường này.'),
        lengthLessThan(250, 'No more than 250 characters.'),
        (inputValue) => {
          if (inputValue.length < 2) {
            return 'Your field is too short!';
          }
        },
      ],
    }),

    seating_map: useField<string>({
      value: entity?.seating_map ?? '',
      validates: [
        notEmpty('Không được để trống trường này.'),
        (inputValue) => {
          if (inputValue && helpers.isUTF8(inputValue)) return 'Không được sử dụng mã UTF8 ở trường này.';
        },
      ],
    }),
    seating_available: useField<string>({
      value: entity?.seating_available ?? '',
      validates: [
        (inputValue) => {
          if (inputValue && helpers.isUTF8(inputValue)) return 'Không được sử dụng mã UTF8 ở trường này.';
        },
      ],
    }),

    seating_number: useField<string>({
      value: `` + (entity?.seating_number ?? 1),
      validates: [
        (inputVal) => {
          if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
          if (Number(inputVal) < 1) {
            return 'Số ghế phải lớn hơn 0.';
          }
        },
      ],
    }),
    seating_status: useField<number>({
      value: entity?.seating_status ?? 1,
      validates: [
        (inputVal) => {
          if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
        },
      ],
    }),
  };

  const {
    fields,
    submit,
    dirty,
    reset: resetForm,
  } = useForm({
    fields: useFields,

    async onSubmit(values) {
      try {
        // create new
        if (!currentVehicleID) {
          await createEntity({
            seating_name: values.seating_name,
            seating_description: values.seating_description,
            seating_available: values.seating_available,
            seating_map: values.seating_map,
            seating_number: Number(values.seating_number),
            seating_status: values.seating_status,
          });
        } else {
          await updateEntity({
            id: String(currentVehicleID),
            seating_name: values.seating_name,
            seating_description: values.seating_description,
            seating_available: values.seating_available,
            seating_map: values.seating_map,
            seating_number: Number(values.seating_number),
            seating_status: values.seating_status,
          });
        }
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success' };
    },
  });

  const handleConvertSeatAvailableText = (text: string) => {
    const current = (fields.seating_available.value || '').split('|').filter(Boolean);
    const updated = current.includes(text) ? current.filter((item) => item !== text) : [...current, text];
    fields.seating_available.onChange(updated.join('|'));
  };

  /* End form */

  useEffect(() => {
    if (updateSuccess || creatingSuccess) {
      resetForm();
      onClose();
    }
  }, [updateSuccess, creatingSuccess]);

  useEffect(() => {
    if (!currentVehicleID) {
      resetForm();
      setEntity(null);
    }
  }, [currentVehicleID]);

  useEffect(() => {
    const seatNumber = seatMaps.find((item) => item.value === fields.seating_map.value)?.seat_number;
    fields.seating_number.onChange(`` + seatNumber);
    if (fields.seating_map.value === entity?.seating_map) return fields.seating_available.onChange(entity?.seating_available);
    fields.seating_available.onChange('');
  }, [fields.seating_map.value]);

  const Actual_page = (
    <Modal
      open={show}
      onClose={() => onClose()}
      title={currentVehicleID ? 'Cập nhật loại hình vận chuyển' : 'Tạo loại hình vận chuyển'}
      primaryAction={{
        content: currentVehicleID ? 'Cập nhật' : 'Tạo',
        disabled: !dirty,
        loading: updating || creating,
        onAction: submit,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => onClose(),
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <FormLayout>
            <TextField autoFocus autoComplete="off" requiredIndicator label="Tên" {...fields.seating_name} />
            <TextField label="Mô tả" autoComplete="off" {...fields.seating_description} multiline={4} />
            <Select label="Bản đồ ghế" options={seatMaps} {...fields.seating_map} />
            <TextField label="seating_available" autoComplete="off" readOnly {...fields.seating_available} />
            <div className="seating_modal_wrapper">
              <div className="seating_modal_note">
                <span style={{ fontWeight: 'bold' }}>Chú thích</span>
                {SEAT_NOTE.map((item) => (
                  <span key={item.value} style={{ display: 'flex', alignItems: 'center' }}>
                    <SeatIcon type={item.value} />
                    <span style={{ color: item.value === 'disabled' ? '#ccc' : 'inherit' }}>{item.label}</span>
                  </span>
                ))}
              </div>
              <SeatContainer
                handleConvertSeatAvailableText={handleConvertSeatAvailableText}
                seatMap={fields.seating_map.value}
                seatAvailable={fields.seating_available.value}
              />
            </div>
            <Checkbox
              label="Đang hoạt động"
              checked={Boolean(fields.seating_status.value === 1)}
              onChange={(e) => fields.seating_status.onChange(Number(e))}
            />
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );

  return <>{Actual_page}</>;
}

